// Display helpers for the endpoint cases page.

export function formatCount (value) {
  if (typeof value !== 'number' || !isFinite(value)) return '—'
  return value.toLocaleString('en-US')
}

export function formatDate (value) {
  if (!value) return '—'
  return new Date(value).toLocaleString('en-CO', {
    timeZone: 'America/Bogota',
    hour12: false
  })
}

export function windowLabel (hours) {
  if (hours === 1) return 'Last hour'
  if (hours < 48) return `Last ${hours} hours`
  return `Last ${Math.round(hours / 24)} days`
}
